<div>
  <small class="error">
    {{ message }}
  </small>
</div>